'use strict';

var _ = require('lodash');
var ConfigurationDiscontinuedRoutesTransformerFactory = function ConfigurationDiscontinuedRoutesTransformerFactory($rootScope, DataTransformer, momentService) {
  function ConfigurationDiscontinuedRoutesTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-discontinued-routes-mode';
    this.priority = 1;
  }
  ConfigurationDiscontinuedRoutesTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  ConfigurationDiscontinuedRoutesTransformerFactory.constructor = ConfigurationDiscontinuedRoutesTransformerFactory;
  ConfigurationDiscontinuedRoutesTransformerFactory.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationDiscontinuedRoutesTransformerFactory.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationDiscontinuedRoutesTransformerFactory.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  function getRoute(segments) {
    var segmentsCount = segments.length;
    if (segmentsCount === 1) {
      var segment = segments[0];
      return segment.origin + (segment.number ? '-' + segment.number + '-' : ' (all) ') + segment.destination;
    }
    var route = '';
    for (var i = 0; i < segmentsCount; i++) {
      if (i === 0) {
        route += segments[i].origin;
      }
      route += segments[i].number ? '-' + segments[i].number + '-' : '-';
      route += segments[i].destination;
    }
    return route;
  }
  ConfigurationDiscontinuedRoutesTransformerFactory.prototype.transform = function (data) {
    var discontinuedRoutes = data.domain.results;
    var result = [];
    var memorizedMomentOfDate = _.memoize(getMomentOfDate);
    var dataSize = discontinuedRoutes.length;
    for (var i = 0; i < dataSize; ++i) {
      var value = discontinuedRoutes[i];
      result.push({
        technicalId: value.technicalId,
        origin: value.origin,
        destination: value.destination,
        route: getRoute(value.discontinuedSegments),
        discontinuedSegments: value.discontinuedSegments,
        departureDateRangeStart: value.departureDateRangeStart ? memorizedMomentOfDate(value.departureDateRangeStart, momentService.FIELD.DEPARTURE_DATE) : undefined,
        departureDateRangeEnd: value.departureDateRangeEnd ? memorizedMomentOfDate(value.departureDateRangeEnd, momentService.FIELD.DEPARTURE_DATE) : undefined,
        connectingServices: value.connectingServices
      });
    }
    return result;
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return ConfigurationDiscontinuedRoutesTransformerFactory;
};
ConfigurationDiscontinuedRoutesTransformerFactory.$inject = ['$rootScope', 'DataTransformerFactory', 'MomentService'];
module.exports = ConfigurationDiscontinuedRoutesTransformerFactory;